import request from '@/util/request';
import qs from 'qs';
// 获取项目
export const getprojectlistreport = (params, options) =>
request.get('/api/v4ward/valueCostBudget/getprojectlistreport', Object.assign({}, options, { params }));
// 获取周期
export const getperiodlistreport = (params, options) =>
request.get('/api/v4ward/valueCostBudget/getperiodlistreport', Object.assign({}, options, { params }))


